<app-confirm-delete-product-part [(display)]="confirmMarkProdObsDisplay"
                                 [header]="confirmMarkProdObsHeader"
                                 [typeConfirmation]="confirmMarkProdObsConfirmation"
                                 [confirmText]="confirmMarkProdObsText"
                                 [messageText]="confirmMarkProdObsMessage"
                                 (done)="onMarkProdObsConfirmation($event)"></app-confirm-delete-product-part>

<app-prodgroup-search [(display)]="displayGS" [groupId]="groupId" (selectedGroup)="onSelectedGroup($event)" closeOnSelection="false"></app-prodgroup-search>

<app-select-product-category [(display)]="displayGG" [selectedProduct]="selectedProduct" (selectedProductCategoryEmitter)="onSelectProductCategory($event)"></app-select-product-category>

<app-rename-something-dialog [(display)]="displaySC" header="Присвоить Код УКТЗЭД" inputLabel="Введите новый код" [textToRename]="codeString" (onRename)="onEnterCodeString($event)"></app-rename-something-dialog>

<p-toolbar styleClass="" *ngIf="showToolBar">
  <ng-template pTemplate="left">
    <!--<p-button label="Добавить" icon="pi pi-plus" styleClass="p-button-success mr-2" (onClick)="onNewCurrencyRate($event)"
            [disabled]="editMode" pTooltip="Добавить курс выбранной валюты" tooltipPosition="top"></p-button>
    <p-button label="Delete" icon="pi pi-trash" styleClass="p-button-danger" (onClick)="onDeleteCurrencyRow($event)"
            [disabled]="editMode || !isThereSelectedRow" pTooltip="Удалить выбранный курс" tooltipPosition="top"></p-button>-->
  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
              pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

    <p-button icon="pi pi-refresh" label="Обновить таблицу" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
              pTooltip="Обновить данные в таблице" tooltipPosition="top"></p-button>

  </ng-template>
</p-toolbar>

<p-table #prodTable [value]="productList"
         [totalRecords]="totalRecords"
         [loading]="loading"
         [paginator]="true"
         paginatorPosition="both"
         [rows]="rows"
         [showCurrentPageReport]="true"
         [rowsPerPageOptions]="[10,20,50,100]"
         currentPageReportTemplate="Показано от {first} до {last} из {totalRecords} товаров"
         selectionMode="multiple"
         [(selection)]="selectedProduct"
         dataKey="PRODCODE"
         styleClass="p-datatable-gridlines p-datatable-striped"
         stateStorage="local"
         (onStateSave)="onStateSave($event)"
         (onStateRestore)="onStateRestore($event)"
         rowExpandMode="single"
         [resizableColumns]="true"
         columnResizeMode="fit"
         filterDelay="200"
         [columns]="selectedColumns"
         sortField="PRODCODE"
         (onRowSelect)="onRowSelect($event)"
         (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)">

  <ng-template pTemplate="caption" *ngIf="showCaption">
    <div class="grid formgrid justify-content-end col-12">
      <p-progressSpinner *ngIf="progress > 1" [style]="{width: '2rem', height: '2rem'}"
                         styleClass="custom-spinner mr-3" strokeWidth="4" fill="#EEEEEE" animationDuration=".5s"
                         pTooltip="Загружается состояние склада" tooltipPosition="top">

      </p-progressSpinner>

      <p-selectButton [options]="showProductOptions" [(ngModel)]="showObsoleteProducts"
                      multiple="multiple" optionLabel="name" optionValue="value"
                      (onChange)="onObsoleteOptionChange($event)" styleClass="mr-3"
                      pTooltip="Показывать устаревшие и актуальные товары" tooltipPosition="top">
      </p-selectButton>

      <p-multiSelect #colset [options]="columns" optionDisabled="nonhide" optionLabel="header" [maxSelectedLabels]="1"
                     placeholder="Выбрать поля" [(ngModel)]="selectedColumns"
                     dataKey="field" styleClass="mr-3"
                     selectedItemsLabel="{0} столбцов"
                     pTooltip="Выбрать поля товара для отображения" tooltipPosition="top">
      </p-multiSelect>

      <div class="fluid mr-3">
        <app-currencyselector #plcs1 labelKey="Валюта" [showLabel]="false" [selectedID]="usdCurrencyId" (SelectedCurrency)="onCurrencyChange($event)"></app-currencyselector>
      </div>

      <p-splitButton label="Очистить" icon="pi pi-circle-off" [model]="items" styleClass="p-button-success hide-label mr-2" [disabled]="noSelection" (onClick)="clearSelection($event)"
                     pTooltip="Очистить выбор товаров" tooltipPosition="top"></p-splitButton>

      <p-splitButton label="XLSX" icon="pi pi-file-excel" [model]="excelExportItems" styleClass="p-button-info hide-label mr-8"
                     [disabled]="noSelection" (onDropdownClick)="checkCommand($event)" (onClick)="onExportData()"
                     pTooltip="Экспортировать список товаров в MS Excel формате" tooltipPosition="top"></p-splitButton>

    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 3rem; max-width: 45px !important">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th style="width: 3rem; max-width: 35px !important"></th>
      <th *ngIf="visiblePRODCODEColumn" pResizableColumn pSortableColumn="PRODCODE" style="width: 15% !important; max-width: 200px !important">Код <p-sortIcon field="PRODCODE"></p-sortIcon></th>
      <th *ngIf="visiblePRODARTICULColumn" pResizableColumn pSortableColumn="PRODARTICUL" style="width: 15% !important">Артикул <p-sortIcon field="PRODARTICUL"></p-sortIcon></th>
      <th *ngIf="visiblePRODCUSTCODEColumn" pResizableColumn pSortableColumn="PRODCUSTCODE" style="width: 8% !important">УКТЗЕД <p-sortIcon field="PRODCUSTCODE"></p-sortIcon></th>
      <th *ngIf="visiblePRODNAMEColumn" pResizableColumn pSortableColumn="PRODNAME" style="width: auto !important; max-width: 2000px !important">Название <p-sortIcon field="PRODNAME"></p-sortIcon></th>
      <th *ngIf="visiblePRODDESCRIPTIONColumn" pResizableColumn pSortableColumn="PRODDESCRIPTION" style="width: auto !important; max-width: 200px !important">Описание <p-sortIcon field="PRODDESCRIPTION"></p-sortIcon></th>
      <th *ngIf="visiblePRODNOTEColumn" pResizableColumn pSortableColumn="PRODNOTE" style="width: auto !important; max-width: 2000px !important">Примечание <p-sortIcon field="PRODNOTE"></p-sortIcon></th>
      <th *ngIf="visiblePRODGROUPNAMEColumn" pResizableColumn pSortableColumn="PRODGROUPNAME" style="width: 10% !important;max-width:200px!important">Группа <p-sortIcon field="PRODGROUPNAME"></p-sortIcon></th>
      <th *ngIf="visiblePRODVENDORNAMEColumn" pResizableColumn pSortableColumn="PRODVENDORNAME" style="width: 10% !important">Производитель <p-sortIcon field="PRODVENDORNAME"></p-sortIcon></th>
      <th *ngIf="visiblePRODPRICEUAHColumn" pResizableColumn pSortableColumn="PRODPRICEUAH" style="width: 7% !important">Цена <p-sortIcon field="PRODPRICEUAH"></p-sortIcon></th>
      <th *ngIf="visiblePRODPRICEUSDColumn" pResizableColumn pSortableColumn="PRODPRICEUSD" style="width: 7% !important">В валюте <p-sortIcon field="PRODPRICEUSD"></p-sortIcon></th>
      <th *ngIf="visiblePRODSTOCKColumn" pResizableColumn pSortableColumn="PRODSTOCK" style="width: 6% !important">Склад <p-sortIcon field="PRODSTOCK"></p-sortIcon></th>
      <th *ngIf="visiblePRODPRICEUAH2Column" pResizableColumn pSortableColumn="PRODPRICEUAH2" style="width: 7% !important">Цена <p-sortIcon field="PRODPRICEUAH2"></p-sortIcon></th>
      <th *ngIf="visiblePRODPRICEUSD2Column" pResizableColumn pSortableColumn="PRODPRICEUSD2" style="width: 7% !important">В валюте <p-sortIcon field="PRODPRICEUSD2"></p-sortIcon></th>
    </tr>
    <tr *ngIf="showFilterHeader">
      <th style="width: 3rem"></th>
      <th style="width: 3rem"></th>
      <th *ngIf="visiblePRODCODEColumn">
        <div *ngIf="filterPRODCODEColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="text" placeholder="Поиск по коду" class="p-dropdown-filter-style"
                 [(ngModel)]="prodCodeFilter" (input)="prodTable.filter($event.target.value, 'PRODCODE', 'contains')">
        </div>
      </th>
      <th *ngIf="visiblePRODARTICULColumn">
        <div *ngIf="filterPRODARTICULColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="text" placeholder="Поиск по артикулу" class="p-dropdown-filter-style"
                 [(ngModel)]="prodArticulFilter" (input)="prodTable.filter($event.target.value, 'PRODARTICUL', 'in')">

        </div>
      </th>
      <th *ngIf="visiblePRODCUSTCODEColumn">
        <div *ngIf="filterPRODCUSTCODEColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="text" placeholder="Поиск по УКТЗЕД" class="p-dropdown-filter-style"
                 [(ngModel)]="custCodeFilter" (input)="prodTable.filter($event.target.value, 'PRODCUSTCODE', 'contains')">

        </div>
      </th>
      <th *ngIf="visiblePRODNAMEColumn">
        <div *ngIf="filterPRODNAMEColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="text" placeholder="Поиск по названию" class="p-dropdown-filter-style"
                 [(ngModel)]="prodNameFilter" (input)="prodTable.filter($event.target.value, 'PRODNAME', 'contains')">
        </div>
      </th>
      <th *ngIf="visiblePRODDESCRIPTIONColumn">
        <div *ngIf="filterPRODDESCRIPTIONColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="text" placeholder="Поиск по описанию" class="p-dropdown-filter-style"
                 [(ngModel)]="prodDescFilter" (input)="prodTable.filter($event.target.value, 'PRODDESCRIPTION', 'contains')">

        </div>
      </th>
      <th *ngIf="visiblePRODNOTEColumn">
        <div *ngIf="filterPRODNOTEColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="text" placeholder="Поиск по примечанию" class="p-dropdown-filter-style"
                 [(ngModel)]="prodNoteFilter" (input)="prodTable.filter($event.target.value, 'PRODNOTE', 'contains')">

        </div>
      </th>
      <th *ngIf="visiblePRODGROUPNAMEColumn">
        <div *ngIf="filterPRODGROUPNAMEColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="text" placeholder="Поиск по группе" class="p-dropdown-filter-style"
                 [(ngModel)]="prodGroupFilter" (input)="prodTable.filter($event.target.value, 'PRODGROUPNAME', 'contains')">

        </div>
      </th>
      <th *ngIf="visiblePRODVENDORNAMEColumn">
        <div *ngIf="filterPRODVENDORNAMEColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="text" placeholder="Поиск по прозводителю" class="p-dropdown-filter-style"
                 [(ngModel)]="prodVendorFilter" (input)="prodTable.filter($event.target.value, 'PRODVENDORNAME', 'contains')">

        </div>
      </th>
      <th *ngIf="visiblePRODPRICEUAHColumn">
        <div *ngIf="filterPRODPRICEUAHColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="number" placeholder="Поиск по цене" class="p-dropdown-filter-style"
                 [(ngModel)]="prodPriceUahFilter" (input)="prodTable.filter($event.target.value, 'PRODPRICEUAH', 'GteOrZero')">
        </div>
      </th>
      <th *ngIf="visiblePRODPRICEUSDColumn">
        <div *ngIf="filterPRODPRICEUSDColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="number" placeholder="Поиск по цене" class="p-dropdown-filter-style"
                 [(ngModel)]="prodPriceUsdFilter" (input)="prodTable.filter($event.target.value, 'PRODPRICEUSD', 'GteOrZero')">
        </div>
      </th>
      <th *ngIf="visiblePRODSTOCKColumn">
        <div *ngIf="filterPRODSTOCKColumn" class="flex p-jc-between align-items-center">
          <input pInputText type="number" placeholder="Поиск по cкладу" class="p-dropdown-filter-style"
                 [(ngModel)]="prodStockBeFilter" (input)="prodTable.filter($event.target.value, 'PRODSTOCK', 'GteOrZero')">
        </div>
      </th>
      <th *ngIf="visiblePRODPRICEUAH2Column">
        <div *ngIf="filterPRODPRICEUAH2Column" class="flex p-jc-between align-items-center">
          <input pInputText type="number" placeholder="Поиск по цене" class="p-dropdown-filter-style"
                 [(ngModel)]="prodPriceUah2Filter" (input)="prodTable.filter($event.target.value, 'PRODPRICEUAH2', 'GteOrZero')">
        </div>
      </th>
      <th *ngIf="visiblePRODPRICEUSD2Column">
        <div *ngIf="filterPRODPRICEUSD2Column" class="flex p-jc-between align-items-center">
          <input pInputText type="number" placeholder="Поиск по цене" class="p-dropdown-filter-style"
                 [(ngModel)]="prodPriceUsd2Filter" (input)="prodTable.filter($event.target.value, 'PRODPRICEUSD2', 'GteOrZero')">
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-prod let-expanded="expanded">
    <tr [class.complex]="(prod.PRODKIND==1)" [class.obsoleted]="(prod.PRODOBSOLETE == 1)" [class.onstock]="(prod.PRODSTOCK > 0)">
      <td>
        <p-tableCheckbox [value]="prod" [checked]="prod.changed"></p-tableCheckbox>
      </td>
      <!--<td style="width: 3rem">...</td>-->
      <td style="width: 3rem">
        <button type="button" pButton pRipple
                [pRowToggler]="prod" class="p-button-text p-button-rounded p-button-plain"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
        </button>
      </td>
      <td *ngIf="visiblePRODCODEColumn" style="width: 15% !important; max-width: 200px !important">
        <a [routerLink]="['/edit-product', prod.PRODID]">{{prod.PRODCODE}}</a>
      </td>
      <td *ngIf="visiblePRODARTICULColumn">{{prod.PRODARTICUL}}</td>
      <td *ngIf="visiblePRODCUSTCODEColumn">{{prod.PRODCUSTCODE}}</td>
      <td *ngIf="visiblePRODNAMEColumn">{{prod.PRODNAME}}</td>
      <td *ngIf="visiblePRODDESCRIPTIONColumn">{{prod.PRODDESCRIPTION}}</td>
      <td *ngIf="visiblePRODNOTEColumn">{{prod.PRODNOTE}}</td>
      <td *ngIf="visiblePRODGROUPNAMEColumn">
        <a [routerLink]="['/products', prod.PRODGROUP]">{{prod.PRODGROUPNAME}}</a>
      </td>
      <td *ngIf="visiblePRODVENDORNAMEColumn">{{prod.PRODVENDORNAME}}</td>
      <td *ngIf="visiblePRODPRICEUAHColumn" style="text-align: right">{{prod.PRODPRICEUAH | number:'1.2-2' }}</td>
      <td *ngIf="visiblePRODPRICEUSDColumn" style="text-align: right">{{prod.PRODPRICEUSD | number:'1.2-2' }}</td>
      <td *ngIf="visiblePRODSTOCKColumn" style="text-align: right">{{prod.PRODSTOCK | number:'1.0-2' }}</td>
      <td *ngIf="visiblePRODPRICEUAH2Column" style="text-align: right">{{prod.PRODPRICEUAH2 | number:'1.2-2' }}</td>
      <td *ngIf="visiblePRODPRICEUSD2Column" style="text-align: right">{{prod.PRODPRICEUSD2 | number:'1.2-2' }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-prod>
    <tr [ngSwitch]="columnCounter()">
      <td *ngSwitchCase="7" colspan="7">
        <div class="p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="8" colspan="8">
        <div class="p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="9" colspan="9">
        <div class="p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="10" colspan="10">
        <div class="p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
      <td *ngSwitchCase="11" colspan="11">
        <div class="p-2">
          <app-product-info [prodId]="prod.PRODID" [currencyId]="usdCurrencyId"></app-product-info>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr [ngSwitch]="columnCounter()">
      <td *ngSwitchCase="7" colspan="7">{{noData}}</td>
      <td *ngSwitchCase="8" colspan="8">{{noData}}</td>
      <td *ngSwitchCase="9" colspan="9">{{noData}}</td>
      <td *ngSwitchCase="10" colspan="10">{{noData}}</td>
      <td *ngSwitchCase="11" colspan="11">{{noData}}</td>
    </tr>
  </ng-template>
</p-table>
